export default __webpack_public_path__ + "static/media/2.1de41c3b.svg";